import { alpha, Chip, useTheme } from '@mui/material'
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder'

interface IProps {
  text: string
  onClick: (text: string) => void
}

export const PopularQuestionsItem = ({ text, onClick }: IProps) => {
  const theme = useTheme()

  const handleClick = () => {
    onClick(text)
  }

  return (
    <Chip
      onClick={handleClick}
      sx={{
        backgroundColor: theme.palette.custom.grey3,
        color: theme.palette.custom.white,
        p: '6px 12px',
        '&:hover': {
          backgroundColor: alpha(theme.palette.custom.grey3, 0.8),
        },
      }}
      icon={<FavoriteBorderIcon sx={{ fill: theme.palette.custom.white }} />}
      label={text}
    />
  )
}
